module.exports = __webpack_public_path__ + "img/Apple - AirPods Max.3bdf19e6.jpg";